import React from 'react';
import cx from 'classnames';
import AmiraIconButton, { ICON_BUTTON_TYPES } from '../Global/AmiraIconButton2/AmiraIconButton2';

export default function SequencingPromptBar({
  hidePrompt,
  hideRepeat,
  onRepeatClick,
  repeatDisabled,
  showRepeatPointer,
}) {
  return (
    <div className={cx('sequencing__prompt', { hidden: hidePrompt })}>
      <div className={cx('sequencing__repeatBtn', { hidden: hideRepeat })}>
        <AmiraIconButton
          type={ICON_BUTTON_TYPES.REPEAT_AUDIO}
          secondary
          onClick={onRepeatClick}
          disabled={repeatDisabled}
          pointerPosition="left"
          showPointer={showRepeatPointer}
        />
      </div>
    </div>
  );
}
